import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IUseMobileTopBottomColor {
  circadiaEngineProvider: ICircadiaEngineProvider;
}

export const useMobileTopBottomColor = ({
  circadiaEngineProvider,
}: IUseMobileTopBottomColor) => {
  const location = useLocation();
  useEffect(() => {
    // Function to update colors based on current hash
    const updateColors = () => {
      if (
        location.pathname.includes("get-started") ||
        location.pathname.includes("login") ||
        location.pathname.includes("otp") ||
        location.pathname.includes("otp-verification") ||
        location.pathname.includes("notification-settings") ||
        location.pathname.includes("floor-settings") ||
        location.pathname.includes("delete-account")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#ebfdff", "#ebfdff");
      } else if (
        location.pathname.includes("flag/chime") ||
        location.pathname.includes("bed-exit/chime") ||
        location.pathname.includes("escalation/chime")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#161646", "#161646");
      } else if (location.pathname.includes("ai-coach")) {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#f8fafb");
      } else if (
        location.pathname.includes("connect-device") ||
        location.pathname.includes("/setup/wifi") ||
        location.pathname.includes("device-manage") ||
        location.pathname.includes("terms-of-use") ||
        location.pathname.includes("privacyPolicy")
      ) {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#f8fafb");
      } else {
        circadiaEngineProvider.changeAppTopAndBottom("#f8fafb", "#ffffff");
      }
    };
    updateColors();
  }, [location.pathname]);

  return null;
};
